import {useEffect, useRef} from "react";
import Days from "../../../../utils/constants/Days";

let ModalTimeTable = (props) => {
    let registerTable = useRef();
    useEffect(() => {
        if (registerTable) {
            let days = Days.keyset_render;
            let times = Days.timeset;
            let column_count = days.length + 1;
            let row_count = times.length + 1;
            registerTable.current.style["grid-template-columns"] = 'repeat(' + column_count + ', 1fr)';
            registerTable.current.style["grid-template-rows"] = 'repeat(' + row_count + ', 1fr)';
        }
    }, [props.currentTeacher, props.dailyTable])
    let onClickTime = (time) => {
        let days = Days.keyset_render;
        let element = document.querySelectorAll("[id$='" + time + "'][class*='register-table-cell']")
        let selected = document.querySelectorAll("[id$='" + time + "'][class*='register-table-cell-selected']")
        if (selected.length === days.length) {
            unselectAll(selected);
        } else {
            selectAll(element);
        }
    }
    let onClickDay = (day) => {
        let times = Days.timeset;
        let element = document.querySelectorAll("[id*='" + day + "'][class*='register-table-cell']")
        let selected = document.querySelectorAll("[id*='" + day + "'][class*='register-table-cell-selected']")
        if (selected.length === times.length) {
            unselectAll(selected)
        } else {
            selectAll(element)
        }
    }
    let selectAll = (elements) => {
        for (let e of elements)
            select(e)
    }
    let unselectAll = (elements) => {
        for (let e of elements)
            unselect(e)
    }
    /**
     * 선택
     * @param {HTMLElement} element
     */
    let select = (element) => {
        element.className = "register-table-cell register-table-cell-selected"
    }
    /**
     *
     * @param {HTMLElement} element
     */
    let unselect = (element) => {
        element.className = "register-table-cell"
    }
    let fillTable = () => {
        let days = Days.keyset_render;
        let days_korean = Days.korean_render
        let times = Days.timeset;

        let column_count = days.length + 1;

        let teacherTable = props.dailyTable[props.currentTeacher];
        let currentTable;
        if (typeof teacherTable === "undefined") {
            currentTable = {}
            for (let day of days) {
                currentTable[day] = [];
            }
        } else {
            currentTable = teacherTable.times;
        }
        let ret = [<div className={"register-table-cell register-table-cell-key"} key={"very-first-cell"}/>]

        for (let i = 0; i < column_count; i++) {
            if (i === 0) {
                for (let j = 0; j < times.length; j++) {
                    let key = "register-table-time-title" + times[j]
                    ret.push(<div className="register-table-cell register-table-title register-time-title register-table-cell-key" key={key}
                                  onClick={() => onClickTime(times[j])}
                    >
                        <p>{times[j] + ":00"}</p>
                    </div>)
                }
            } else {
                let dayKey = days[i - 1]; //mon, tue,..
                ret.push(<div className="register-table-cell register-table-title register-day-title register-table-cell-key"
                              key={"table-cell-title" + days_korean[i - 1]}
                              onClick={() => onClickDay(dayKey)}
                >
                    <p>{days_korean[i - 1]}</p>
                </div>)
                for (let j = 0; j < times.length; j++) {
                    let selectableTime = times[j]
                    let isSelected = false;
                    if (currentTable[dayKey].indexOf(selectableTime) !== -1) {
                        isSelected = true;
                    }
                    let id = "register-table-selectable:" + dayKey + ":" + selectableTime;
                    ret.push(<div className={isSelected ? "register-table-cell register-table-cell-selected"
                        : "register-table-cell"} key={id} id={id} onClick={(e) => {
                        if (e.target.className === "register-table-cell register-table-cell-selected") {
                            unselect(e.target)
                        } else {
                            select(e.target)
                        }
                    }}>
                    </div>)
                }
            }
        }
        return ret;
    }
    return <div className="register-table" ref={registerTable}>
        {fillTable()}
    </div>
}
export default ModalTimeTable